import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useFormikContext } from 'formik';
import React from 'react';
import { StyledInput as CheggUiInput } from '../Shared/styled';
import { noop } from '@chegg/utils';
import { RadioGroup } from './RadioGroup';
export var RadioGroupWithInput = function RadioGroupWithInput(_ref) {
  var legend = _ref.legend,
    inputName = _ref.inputName,
    options = _ref.options,
    radioName = _ref.radioName,
    radioFormikName = _ref.radioFormikName,
    defaultSelectedIndex = _ref.defaultSelectedIndex,
    align = _ref.align,
    changeOptionOnInputFocus = _ref.changeOptionOnInputFocus,
    dataTestId = _ref['data-test'];
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var selectedSearchOption = options.findIndex(function (option) {
    var _values$pubdatabase;
    return option.key === (values === null || values === void 0 ? void 0 : (_values$pubdatabase = values.pubdatabase) === null || _values$pubdatabase === void 0 ? void 0 : _values$pubdatabase.searchtype);
  });
  var selectedPlaceholderText = options[selectedSearchOption >= 0 ? selectedSearchOption : 0].placeholderText;
  var _inputName$split = inputName.split('.'),
    _inputName$split2 = _slicedToArray(_inputName$split, 2),
    inputPath = _inputName$split2[0],
    inputKey = _inputName$split2[1];
  var inputValue = values[inputPath] && values[inputPath][inputKey];
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RadioGroup, {
    name: radioName,
    formikFieldName: radioFormikName,
    options: options,
    legend: legend,
    align: align,
    "data-test": dataTestId + '_rg',
    onChange: noop,
    defaultSelectedIndex: defaultSelectedIndex
  }), /*#__PURE__*/React.createElement(CheggUiInput, {
    labelText: "input for ".concat(options[options.length - 1], " option"),
    visuallyHideLabel: true,
    inputId: inputName,
    value: inputValue || '',
    onChange: function onChange(val) {
      return setFieldValue(inputName, val);
    },
    onFocus: function onFocus() {
      changeOptionOnInputFocus && setFieldValue(radioFormikName, options[options.length - 1].key);
    },
    placeholder: selectedPlaceholderText
  }));
};